module.exports = __webpack_public_path__ + "img/bi.75d5af3d.svg";